<template>
	<div class="card-main">
		<article class="warp">
			<figure class="warp-left">
				<img :src="cardData.Icon">
			</figure>

			<section class="warp-center" v-if="[603, 13].indexOf(Number(cardData.ProductId)) != -1 && cardData.ExtendData && cardData.ExtendData.ShowCardAsList && cardData.ExtendData.ShowCardAsList.length > 0">
				<div v-for="(item, index) in cardData.ExtendData.ShowCardAsList" :key="index" v-if="(cardData.ProductId == 13 && 2 > index) || cardData.ProductId == 603">
					<double-row :Titles="item.Titles" v-if="[5, 6, 20, 610, 611, 612, 614].indexOf(Number(item.ProductId)) != -1"></double-row>
					<english :Titles="item.Titles" v-else-if="[25, 48].indexOf(Number(item.ProductId)) != -1"></english>
					<start-stop :Titles="item.Titles" v-else-if="[34, 604].indexOf(Number(item.ProductId)) != -1 || (item.ProductId == 45 && item.Titles && item.Titles.length > 1)"></start-stop>
					<single-row :Titles="item.Titles" v-else></single-row>

					<double-desc :Contents="item.Contents" v-if="[4, 5, 20, 25, 47, 48, 603, 605, 606, 608, 613, 614].indexOf(Number(item.ProductId)) != -1"></double-desc>
					<single-desc :Contents="item.Contents" v-else></single-desc>
				</div>

				<div v-if="cardData.ProductId == 13 && cardData.ExtendData.ShowCardAsList.length > 2" class="more-list">更多航程查看详情</div>
			</section>

			<section class="moresegs" v-else-if="cardData.ProductId == 1 && cardData.ExtendData && cardData.ExtendData.IsMoreSegs && cardData.ExtendData.IsMoreSegs == 1">
				<div class="moresegs-box" v-for="(item, index) in cardData.ExtendData.Segments" v-if="index < 2">
					<div class="moresegs-title">
						<h3 class="one-line">{{item.AirLineDes}}</h3>
					</div>
					<div class="moresegs-desc">
						<span class="moresegs-text one-line">{{item.FlightNo}}</span>
						<span class="moresegs-text one-line">{{item.FlyOffDate}}</span>
					</div>
				</div>
				<p v-if="cardData.ExtendData.Segments.length > 2" class="more-range">更多航程查看详情</p>
			</section>

			<section class="moresegs" v-else-if="cardData.ProductId == 618 && cardData.ExtendData && cardData.ExtendData.MutilTitle && cardData.ExtendData.MutilTitle.length">
				<div class="moresegs-box" v-for="(item, index) in cardData.ExtendData.MutilTitle" v-if="index < 3">
					<div class="moresegs-title">
						<h3 class="one-line">{{item.Title}}</h3>
					</div>
					<div class="moresegs-desc">
						<span class="moresegs-text one-line">{{item.SubTitle}}</span>						
					</div>
				</div>
				<p v-if="cardData.ExtendData.MutilTitle.length > 3" class="more-multiflight">更多航程查看详情</p>
			</section>


			<section class="warp-center" v-else>
				<double-row :Titles="cardData.Titles" v-if="cardData.TitleType===1 || [5, 6, 20, 610, 611, 612, 614].indexOf(Number(cardData.ProductId)) != -1"></double-row>
				<english :Titles="cardData.Titles" v-else-if="cardData.TitleType===1 || [25, 48].indexOf(Number(cardData.ProductId)) != -1"></english>
				<start-stop :Titles="cardData.Titles" v-else-if="cardData.TitleType===1 || [34, 604].indexOf(Number(cardData.ProductId)) != -1 || (cardData.ProductId == 45 && cardData.Titles && cardData.Titles.length > 1)"></start-stop>
				<single-row :Titles="cardData.Titles" v-else></single-row>

				<double-desc :Contents="cardData.Contents" v-if="cardData.DescType===1 || [4, 5, 20, 25, 47, 48, 603, 605, 606, 608, 613, 614].indexOf(Number(cardData.ProductId)) != -1"></double-desc>
				<single-desc :Contents="cardData.Contents" v-else></single-desc>
			</section>
		</article>
	</div>
</template>

<script>
import SingleRow from '../template/title/SingleRow'
import DoubleRow from '../template/title/DoubleRow'
import English from '../template/title/English'
import StartStop from '../template/title/StartStop'

import SingleDesc from '../template/desc/SingleDesc'
import DoubleDesc from '../template/desc/DoubleDesc'
export default {
	name: 'CardDetail',
	props: ['cardData'],
	components: {
		SingleRow,
		DoubleRow,
		English,
		SingleDesc,
		StartStop,
		DoubleDesc
	},
}
</script>

<style lang="scss" scoped>
.warp-left {
	margin: 0;
	padding: 0;
}
.warp-left img {
	display: block;
	width: 25px;
	height: 25px;
	margin-right: 10px;
	margin-top: 12px;
}
.warp {
	-webkit-box-flex: 1;
	display: -webkit-box;
}
.warp-center {
	-webkit-box-flex: 1;
}
.moresegs {
	-webkit-box-flex: 1;
	padding: 10px 0 0;
}
.moresegs-box {
	width: 100%;
	margin-bottom: 10px;
}
.moresegs-box:last-of-type {
	margin-bottom: 5px;
}
.moresegs-title {
	display: -webkit-box;
	-webkit-box-align: center;
	-webkit-box-pack: justify;
	height: 30px;
	margin-right: 8px;
	h3 {
		display: block;
		font-size: 16px;
		color: #333;
		font-weight: bold;
		-webkit-box-flex: 1;
	}
}
.moresegs-desc {
	display: -webkit-box;
	-webkit-box-pack: start;
	span {
		display: block;
		font-size: 13px;
		color: #666;
		margin-right: 10px;
	}
	span:last-child {
		margin-right: 0;
	}
}
.more-range {
	font-size: 13px;
	color: #999;
}
.more-list {
	font-size: 13px;
	color: #999;
	padding-top: 10px;
}

.more-multiflight{
  font-size: 13px;
  font-weight: bolder;
  color: #000;  
  padding-top: 10px;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/template/CardDetail.vue